import { SelectChangeEvent } from "@mui/material";
import { Option } from "../../../common/interface/interface";
import { FC } from "react";
import { MultiSelectDropdown } from "../../../common/components/MultiSelect";

interface Props {
  fieldNames: string[];
  options: Option[];
  onChange: (e: SelectChangeEvent<string[]>) => void;
}

export const FieldTags: FC<Props> = ({ fieldNames, options, onChange }) => {
  return (
    <MultiSelectDropdown
      selected={fieldNames}
      options={options}
      onChange={onChange}
    />
  );
};
